import { HttpHeaders, HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { TokenService } from "../core/token/token.service";
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RelatorioAgendadoService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
      params: null
  };

  constructor(private http: HttpClient, private tokenService: TokenService) { }

  getDropdownRelatorioPersonalizado(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/rel-agendado/dropdown-relatorio`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  listarRelatorios(params, payload): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/rel-agendado/listar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  deletarRelatoriosAgendados(relatorios): Observable<any> {
    this.httpOptions.params = null;
    return this.http.request(
      'delete',
      `${this.apiUrl}api/rel-agendado/deletar`,
      {
        body: {ids: relatorios},
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() })
      }
    );
  }

  copiarRelatorioAgendado(relatorio_id): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/rel-agendado/copiar/${relatorio_id}`, null, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  criarRelatorioAgendado(payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/rel-agendado/criar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  atualizarRelatorioAgendado(payload): Observable<any> {
    this.httpOptions.params = null;
    return this.http.put(`${this.apiUrl}api/rel-agendado/atualizar`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  obterRelatorioAgendado(relatorio_id): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/rel-agendado/obter/${relatorio_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropdownContatosRelatorioAgendado(cliente_id): Observable<any> {
    this.httpOptions.params = null;
    return this.http.post(`${this.apiUrl}api/rel-agendado/dropdown-contato`, {cliente_id: cliente_id}, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropdownTipoContatosRelatorioAgendado(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/rel-agendado/dropdown-tipo-contato`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
